import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useLegalAuth } from '../hooks/useLegalAuth';
import { checkTncVersionMatch } from './services/consentService';

// Wraps the authenticated app. Blocks access until the user has accepted
// the current T&C version. SuperAdmins are exempt (per spec).
export default function TncGate({ children }) {
  const { profileDocId, profileLoaded, isSuperAdmin } = useLegalAuth();
  const location = useLocation();
  const [status, setStatus] = useState('checking'); // checking | ok | needs_review

  useEffect(() => {
    if (isSuperAdmin) { setStatus('ok'); return; }
    if (location.pathname === '/tnc-review') { setStatus('ok'); return; }
    if (!profileLoaded) return; // profile lookup still in flight

    // No profile doc means nothing to record consent against. Let the user
    // through (pre-gate behaviour) instead of hanging on a blank screen.
    if (!profileDocId) {
      console.warn('[TncGate] No UserProfileMaster doc for this user; skipping T&C check.');
      setStatus('ok');
      return;
    }

    checkTncVersionMatch(profileDocId)
      .then((result) => setStatus(result.matches ? 'ok' : 'needs_review'))
      .catch((err) => {
        console.error('[TncGate] T&C check failed:', err);
        setStatus('needs_review');
      });
  }, [profileDocId, profileLoaded, isSuperAdmin, location.pathname]);

  if (status === 'checking') return null;
  if (status === 'needs_review') return <Navigate to="/tnc-review" replace />;
  return children;
}
